/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OccupancyLossCostRatesResponseDto
 */
export interface OccupancyLossCostRatesResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof OccupancyLossCostRatesResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OccupancyLossCostRatesResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof OccupancyLossCostRatesResponseDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OccupancyLossCostRatesResponseDto
     */
    occupancyName: string;
    /**
     * 
     * @type {string}
     * @memberof OccupancyLossCostRatesResponseDto
     */
    pdLossCost: string;
    /**
     * 
     * @type {string}
     * @memberof OccupancyLossCostRatesResponseDto
     */
    biLossCost: string;
    /**
     * 
     * @type {string}
     * @memberof OccupancyLossCostRatesResponseDto
     */
    biMultiplier: string;
}

/**
 * Check if a given object implements the OccupancyLossCostRatesResponseDto interface.
 */
export function instanceOfOccupancyLossCostRatesResponseDto(value: object): value is OccupancyLossCostRatesResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('occupancyName' in value) || value['occupancyName'] === undefined) return false;
    if (!('pdLossCost' in value) || value['pdLossCost'] === undefined) return false;
    if (!('biLossCost' in value) || value['biLossCost'] === undefined) return false;
    if (!('biMultiplier' in value) || value['biMultiplier'] === undefined) return false;
    return true;
}

export function OccupancyLossCostRatesResponseDtoFromJSON(json: any): OccupancyLossCostRatesResponseDto {
    return OccupancyLossCostRatesResponseDtoFromJSONTyped(json, false);
}

export function OccupancyLossCostRatesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OccupancyLossCostRatesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'id': json['id'],
        'occupancyName': json['occupancyName'],
        'pdLossCost': json['pdLossCost'],
        'biLossCost': json['biLossCost'],
        'biMultiplier': json['biMultiplier'],
    };
}

export function OccupancyLossCostRatesResponseDtoToJSON(json: any): OccupancyLossCostRatesResponseDto {
    return OccupancyLossCostRatesResponseDtoToJSONTyped(json, false);
}

export function OccupancyLossCostRatesResponseDtoToJSONTyped(value?: OccupancyLossCostRatesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'id': value['id'],
        'occupancyName': value['occupancyName'],
        'pdLossCost': value['pdLossCost'],
        'biLossCost': value['biLossCost'],
        'biMultiplier': value['biMultiplier'],
    };
}

